import React from 'react';

import { StyledDetailsRow } from './details-row.styled';

interface Props {
  children: React.ReactNode;
}

export const DetailsRow = ({ children }: Props) => <StyledDetailsRow>{children}</StyledDetailsRow>;
